import { BooleanAlgebra } from 'fp-ts/boolean';
export * from 'fp-ts/boolean';
export * from 'fp-ts-std/Boolean';
export var implies = BooleanAlgebra.implies, join = BooleanAlgebra.join, meet = BooleanAlgebra.meet, not = BooleanAlgebra.not, one = BooleanAlgebra.one, zero = BooleanAlgebra.zero;
export var isTrue = function (b) { return b === true; };
export var isFalse = function (b) { return b === false; };
export var foldMap = function (M) { return function (f) { return function (b) { return b ? f(b) : M.empty; }; }; };
